import { reportError } from './report-error';
import { csrfHeaders, submitPost } from './csrf';
import { initPhoneFavorite } from './phone-favorite';
import {bindEmailValidation, buildRightInputs, formatInterestOption, formatInterestSelection, launchTooltip, pageConfig, setupParentChildRightsToggle, showFlash, translate} from "./functions";

const { openConfirmation, toggleSectionContentVisibility} = require("./functions");


export function updatePosListUser(posSelect)
{
    posSelect.change(function(){
        const { userId } = pageConfig();
        let initialPosId = $(this).data('pos-id');
        let posIdSelected = $(this).val();
        let interestId = $(this).data('interest');
        let url = $(this).data('url') + `?pos-id=${posIdSelected}&interest-id=${interestId}`;
        if (userId !== undefined && String(initialPosId) === posIdSelected) {
            url += `&current-user-id=${userId}`;
        }
        let associateSellerSelectDisplayed = $(this).closest('.reaffectPosLeadLine').find('div.reaffectPosLeadLine-sellerSelect');
        let associateSellerSelect = $(this).closest('.reaffectPosLeadLine').find('.reaffectPosLeadLine-sellerSelect select');
        let associateSellerSelectLoader = $(this).closest('.reaffectPosLeadLine').find('.reaffectPosLeadLine-sellerSelectLoader');
        let requestHeaders = new Headers({
            'X-Requested-With': 'XMLHttpRequest'
        });
        let requestInit = { method: 'GET',
            headers: requestHeaders,
        };

        associateSellerSelectDisplayed.addClass('--hidden');
        associateSellerSelectLoader.removeClass('--hidden');

        fetch(url, requestInit)
            .then(response => response.json())
            .then(data => {
                associateSellerSelect.find('option').remove();
                data.forEach((user) => {
                    associateSellerSelect.append($('<option/>', {
                        'value': user.id,
                        'text': user.firstName + ' ' + user.lastName
                    }))
                })

                associateSellerSelect.select2().trigger('change');
                associateSellerSelectDisplayed.removeClass('--hidden');
                $('.reaffectPosLeadLine-sellerSelectLoader').addClass('--hidden');
            })
            .catch(function(error) {
                associateSellerSelectLoader.addClass('--hidden');
                associateSellerSelectDisplayed.removeClass('--hidden');
                reportError('Rechargement de la liste des vendeurs impossible', error);
            });
    })
}

$(function ()
{
    const container = $('.main-content-resp.--seller');
    const containerCallUser = $('.main-content-resp.--call-user');

    if (containerCallUser.length > 0 || container.length > 0) {
        function handleForceRoute()
        {
            const { forceRoute = '' } = pageConfig();
            if (forceRoute !== '') {
                let errorMessage = translate('admin.reset_email.already_requested');
                errorMessage += ' ' + translate('admin.reset_email.force');
                // Nouvel envoi forcé : action d'écriture, envoyée en POST avec le jeton CSRF.
                openConfirmation({'text': errorMessage, 'action': submitPost, 'param': forceRoute});
            }
        }
        handleForceRoute();
    }

    if (container.length > 0) {

        const formUserArchiveModalLink = container.find("#user-archive-form-modal-link");
        const formClosePosModalLink = container.find("#user-close-pos-form-modal-link");
        const formClosePosModalContent = container.find(".user-close-pos-form-modal-content");
        const formClosePosModalLoader = formClosePosModalContent.find(".common-loader");
        const selectManager = container.find('.pos-select-manager');
        const selectRoles = container.find('.pos-select-roles');
        const selectOrganizationsLoader = container.find('.organizations-loader-wrapper');
        const selectOrganizationsWrapper = container.find('.field-organizations-wrapper');
        const selectOrganizations = container.find('.select-organizations');
        const selectBilledPosLoader = container.find('.billed-pos-loader-wrapper');
        const selectBilledPosWrapper = container.find('.select-billed-pos-wrapper');
        const selectBilledPos = container.find('.select-billed-pos');
        const selectAssignedSources = container.find('.select-assigned-source');
        const phoneNumberInput = container.find('#seller_phoneNumber');
        const mobilePhoneNumberInput = container.find('#seller_mobilePhoneNumber');
        const favoritePhoneNumberInput = container.find('#seller_favoritePhoneNumber');
        const weeklyReportRoleInput = container.find('.WEEKLY_REPORT_CRON input');
        const affectationSection = container.find('.affectation_section');
        const interestLoader = container.find('.user-interest-loader-wrapper');
        const interestSelectWrapper = container.find('.interest_bloc');
        const interestSelects = container.find('.interest_select');
        const interestAssignmentSelect = container.find('.assignment_interest_select');
        const interestVisibleSelect = container.find('.visible_interest_select');
        const archiveUserLink = container.find('.archive-user-link');
        const unarchiveUserLink = container.find('#user-unarchive-link');
        const unarchiveUserLoader = container.find('.user-unarchive-loader');
        const monthlyReportEmailCheckbox = container.find('input[type="checkbox"][value="MONTHLY_REPORT_CRON"]');
        const internalStatsCheckbox = container.find('input[type="checkbox"][value="ROLE_INTERNAL_STATS"]');
        const blockLibelles = container.find('#blockLibelles');
        const selectStatLibelle = container.find('.select-stat-libelle');
        const noTechnicalElement = container.find('.--no-technical');
        const virtualHiddenElements = container.find('[data-virtual-hide]');
        // Un seul point de déclaration pour tous les inputs de droits (API/MCP/Documentation +
        // les droits à logique de visibilité par rôle ci-dessous), au lieu d'une ligne
        // `const xInput = container.find(...)` par droit : accès via rightInputs.<field>.
        // buildRightInputs est mutualisée avec form-call-user.js (cf. functions.js).
        const RIGHT_FIELDS = [
            'rightApi', 'rightApiLeadRead', 'rightApiRefRead', 'rightApiFormWrite', 'rightApiLeadWrite',
            'rightApiWebhookRead', 'rightApiWebhookWrite', 'rightApiCampaignRead', 'rightApiCampaignWrite', 'rightMcp', 'rightMcpFormWrite',
            'anonymizedMcp', 'rightDocumentation',
            'rightTransfer', 'rightExternalBilling', 'canManageAc3Connection', 'rightMonthlyStats', 'rightInternalStats',
            'rightSmsCampaign',
        ];
        const rightInputs = buildRightInputs(container, RIGHT_FIELDS, 'seller_');
        const transferField = rightInputs.rightTransfer.closest('.field');

        let originalInterests = [];
        let removedInterests = [];
        let confirmationState = false

        initializeSelect2();
        initializeFormUserModal();
        initializeBilledPosField();
        onlyNumber()
        handleAcceptedMailTypes();
        handleAcceptedSmsTypes();
        handleLockData();
        emailSectionHandler();
        formValidation();
        availableForLeadHandlerAction();
        transferVisibilityHandler();
        initPhoneFavorite(phoneNumberInput, mobilePhoneNumberInput, favoritePhoneNumberInput);
        titleAutoResolveHandler();
        smsSectionHandler();
        monthlyStatRoleHandlerAction();
        internalStatRoleHandlerAction();
        initInterestSelects();
        handleSelectOrganization();
        handleRemoveOrganization();
        handleArchiveUserAction();
        handleUnarchiveUserAction();
        statUserToggle();
        apiRightsToggle();
        mcpRightsToggle();
        affectationWarningsHandler();
        // Rappelé par updateRoleDisplay() une fois le profil appliqué (droit affiché ou masqué) ; null sans avertissement
        const refreshSmsCampaignWarning = smsCampaignWarningHandler();
        reducedFieldVisibilityHandler();

        function hideRight(input) {
            // Poser disabled avant le uncheck programmatique : un éventuel handler `change`
            // trackant `userTouched` filtrera correctement sur `!this.disabled`.
            input.prop('disabled', true);
            if (input.is(':checked')) {
                input.prop('checked', false).trigger('change');
            }
            input.parents('.field').addClass('--hidden');
        }

        function showRight(input) {
            input.prop('disabled', false);
            input.parents('.field').removeClass('--hidden');
        }

        function apiRightsToggle() {
            setupParentChildRightsToggle(
                rightInputs.rightApi,
                [rightInputs.rightApiLeadRead, rightInputs.rightApiRefRead, rightInputs.rightApiFormWrite, rightInputs.rightApiLeadWrite, rightInputs.rightApiWebhookRead, rightInputs.rightApiWebhookWrite, rightInputs.rightApiCampaignRead, rightInputs.rightApiCampaignWrite],
                [rightInputs.rightApiLeadRead, rightInputs.rightApiRefRead, rightInputs.rightApiWebhookRead],
                showRight,
                hideRight
            );
        }

        // Droit Campagne SMS coché alors qu'aucun PDV du périmètre ne facture les campagnes SMS :
        // le menu ne s'affichera pas, on prévient dès la saisie. Le changement de profil n'est pas écouté
        // ici : son handler passe avant updateRoleDisplay() et lirait l'état du droit d'avant le changement.
        function smsCampaignWarningHandler() {
            const input = rightInputs.rightSmsCampaign;
            const warning = container.find('.sms-campaign-right-warning');
            if (!input.length || !warning.length) {
                return null;
            }
            const url = warning.attr('data-eligibility-url');
            if (!url) {
                reportError('Avertissement Campagne SMS : data-eligibility-url absent', null);
                return null;
            }
            let pending = null;

            function refresh() {
                if (pending) pending.abort();
                const posIds = selectOrganizations.val() || [];
                if (!input.is(':checked') || input.prop('disabled') || posIds.length === 0) {
                    warning.addClass('--hidden');
                    return;
                }
                const payload = new URLSearchParams();
                posIds.forEach(v => payload.append('posIds[]', v));
                payload.append('withDescendants', selectRoles.val() === 'ROLE_GROUP_DIRECTOR' ? '1' : '0');
                pending = $.ajax({
                    url,
                    method: 'POST',
                    data: payload.toString(),
                    contentType: 'application/x-www-form-urlencoded',
                }).done(data => {
                    warning.toggleClass('--hidden', data.eligible === true);
                }).fail((xhr, status, error) => {
                    if (status === 'abort') return;
                    warning.addClass('--hidden');
                    reportError('Vérification de facturation Campagne SMS impossible', error);
                });
            }

            input.on('change', refresh);
            selectOrganizations.on('change', refresh);

            return refresh;
        }

        function affectationWarningsHandler() {
            const icons = container.find('.affect-warning');
            if (!icons.length) return;

            const url = Routing.generate('user_affectation_warnings');
            const sectorInput = container.find('#seller_sector');
            const affectCodeInput = container.find('#seller_affectCode');

            let pending = null;

            function collectPayload() {
                const payload = new URLSearchParams();
                (selectOrganizations.val() || []).forEach(v => payload.append('posIds[]', v));
                (interestAssignmentSelect.val() || []).forEach(v => payload.append('interestIds[]', v));
                (selectAssignedSources.val() || []).forEach(v => payload.append('sourceIds[]', v));
                payload.append('sector', (sectorInput.val() || []).join(','));
                payload.append('affectCode', (affectCodeInput.val() || '').trim());
                return payload;
            }

            function renderWarnings(data) {
                icons.each(function () {
                    const $icon = $(this);
                    const target = $icon.data('affect-warning-target');
                    const lines = data[target] || [];
                    if (lines.length === 0) {
                        $icon.addClass('--hidden');
                        return;
                    }
                    const header = $icon.data('warning-header');
                    $icon.attr('data-title', [header, ...lines].join('\n'));
                    $icon.removeClass('--hidden');
                });
                launchTooltip();
            }

            function refresh() {
                if (pending) pending.abort();
                pending = $.ajax({
                    url: url,
                    method: 'POST',
                    data: collectPayload().toString(),
                    contentType: 'application/x-www-form-urlencoded',
                }).done(renderWarnings);
            }

            let debounceTimer = null;
            function scheduleRefresh() {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(refresh, 250);
            }

            selectOrganizations.on('change', scheduleRefresh);
            interestAssignmentSelect.on('change', scheduleRefresh);
            selectAssignedSources.on('change', scheduleRefresh);
            sectorInput.on('change', scheduleRefresh);
            affectCodeInput.on('input', scheduleRefresh);

            // Éviter le chevauchement : au survol de l'icône, masquer le tooltip du .field parent.
            container.on('mouseenter', '.affect-warning', function () {
                const fieldEl = $(this).closest('.field').get(0);
                if (fieldEl && fieldEl._tippy) {
                    fieldEl._tippy.hide();
                }
            });
        }

        // Le CSS de la section .--reduced-completed masque un .field vide via `--has-value`,
        // classe posée ici plutôt que via des sélecteurs [value]/:empty : ces derniers ne
        // reflètent que l'attribut HTML initial et ne réagissent jamais à la saisie live,
        // ce qui masquait un champ dès qu'on tapait dedans (le warning associé disparaissant
        // au même moment).
        function reducedFieldVisibilityHandler() {
            const fields = container.find('.section-content.--reduced-completed .field');
            if (!fields.length) return;

            function hasValue($field) {
                let filled = false;
                $field.find('input[type="text"], input[type="number"], textarea').each(function () {
                    if (($(this).val() || '').toString().trim() !== '') filled = true;
                });
                $field.find('select').each(function () {
                    const val = $(this).val();
                    if (Array.isArray(val) ? val.length > 0 : !!val) filled = true;
                });
                return filled;
            }

            function refresh($field) {
                $field.toggleClass('--has-value', hasValue($field));
            }

            fields.each(function () {
                refresh($(this));
            });

            fields.find('input[type="text"], input[type="number"], textarea').on('input', function () {
                refresh($(this).closest('.field'));
            });
            fields.find('select').on('change', function () {
                refresh($(this).closest('.field'));
            });
        }

        function mcpRightsToggle() {
            setupParentChildRightsToggle(
                rightInputs.rightMcp,
                [rightInputs.rightMcpFormWrite, rightInputs.anonymizedMcp],
                [rightInputs.anonymizedMcp],
                showRight,
                hideRight
            );
        }

        function initializeSelect2()
        {
            selectRoles.select2();
            selectBilledPos.select2();
            // .select-assigned-source est initialisé en select2 ajax-tags par admin.js
            // (liste par défaut + saisie libre) : un second appel select2() ici l'écraserait.
            selectManager.select2({
                allowClear : true,
            });
            selectOrganizations.select2({
                allowClear : true,
                placeholder: selectOrganizations.data('placeholder'),
            });
            selectStatLibelle.select2();
            container.find('.select-sector').select2({
                tags: true,
                // Permet de coller "75001, 75002" : chaque code devient un tag
                tokenSeparators: [',', ';', ' '],
                placeholder: container.find('.select-sector').data('placeholder'),
            });
        }

        function initializeFormUserModal()
        {
            formUserArchiveModalLink.on('click', function(event) {
                event.preventDefault();
                openConfirmation({'class': '--white --high', 'element': $("#user-archive-form-modal"), 'afterClose': afterClose, 'action': validateFormAction});
            })
            formClosePosModalLink.on('click', function(event) {
                event.preventDefault();
                openConfirmation({'class': '--white --high', 'element': $("#user-close-pos-form-modal"), 'afterClose': afterClose, 'action': validateFormAction});
            })
        }

        function afterClose()
        {
            formClosePosModalContent.html('');
            formClosePosModalLoader.removeClass('--hidden');
            selectOrganizationsLoaded();
            // reset popin
            $.get(Routing.generate('default_popin'), function (data) {
                $('.pop-confirmation').replaceWith(data);
            });
        }

        function onlyNumber()
        {
            $('.phone-number').keyup(function () {
                let value = $(this).val().replace(/[^0-9+]/, '');
                $(this).val(value);
            });
        }

        function handleMailRelaunchAction($element)
        {
            let isChecked = $element.is(':checked');
            if ($element.val() === 'LEAD_NEW') {
                if (isChecked === false) {
                    $('.LEAD_NOTIFICATION_WAITING_CRON, .LEAD_NOTIFICATION_LATE_CRON').addClass('--hidden').find('input').prop('checked', false);
                } else {
                    $('.LEAD_NOTIFICATION_WAITING_CRON').removeClass('--hidden');
                }
            }
            if ($element.val() === 'LEAD_NOTIFICATION_WAITING_CRON') {
                if (isChecked === false) {
                    $('.LEAD_NOTIFICATION_LATE_CRON').addClass('--hidden').find('input').prop('checked', false);
                } else {
                    $('.LEAD_NOTIFICATION_LATE_CRON').removeClass('--hidden');
                }
            }
        }

        function handleAcceptedMailTypes()
        {
            //// ENABLE MAIL INPUT ACTION ////
            let handleMailIsCheckedAction = function(elem){
                let isChecked = elem.is(':checked');
                let allTypesMailAccepted = $('.types-mails-accepted input');
                if (!isChecked) {
                    allTypesMailAccepted.prop('checked', false).trigger('change');
                } else {
                    // Défauts déclarés en Twig via data-default (issu de Lead::DEFAULT_LEAD_MAILS_TYPES).
                    allTypesMailAccepted.filter('[data-default]').prop('checked', true).trigger('change');
                }
            };
            let enableMailInput = $('.enable-mail-input');
            enableMailInput.click(function(){
                handleMailIsCheckedAction($(this))
            });

            //// TYPES MAILS ACCEPTED INPUT ACTION ////
            let typesMailAccepted = $('.types-mails-accepted input');

            let handleMaxRelaunchVisibility = function() {
                let waitingCron = $('.types-mails-accepted input[value="LEAD_NOTIFICATION_WAITING_CRON"]');
                let maxRelaunch = $('.max-relaunch');
                if (waitingCron.is(':checked')) {
                    maxRelaunch.removeClass('--hidden');
                } else {
                    maxRelaunch.addClass('--hidden');
                }
            };

            // Décocher le dernier type laisse les e-mails activés, comme les SMS : le vendeur choisit ses types ensuite
            // (« Mon compte » ou app mobile), y compris aucun.
            typesMailAccepted.change(function(){
                let enableEmailInput = $('.enable-mail-input');
                if ($(this).is(':checked') && enableEmailInput.is(':checked') === false) {
                    enableEmailInput.prop('checked', true);
                }
                handleMailRelaunchAction($(this));
                handleMaxRelaunchVisibility();
            });
            typesMailAccepted.each(function() {
                handleMailRelaunchAction($(this));
            })
        }

        function handleAcceptedSmsTypes()
        {
            //// ENABLE SMS INPUT ACTION ////
            let handleSmsIsCheckedAction = function(elem){
                let isChecked = elem.is(':checked');
                let allTypesSmsAccepted = $('.types-sms-accepted input');
                if (!isChecked) {
                    allTypesSmsAccepted.prop('checked', false).trigger('change');
                } else {
                    // Défauts déclarés en Twig via data-default (issu de Lead::DEFAULT_LEAD_SMS_TYPES).
                    allTypesSmsAccepted.filter('[data-default]').prop('checked', true).trigger('change');
                }
            };
            let enableSmsInput = $('.enable-sms-input');
            enableSmsInput.click(function(){
                handleSmsIsCheckedAction($(this))
            });

            //// TYPES SMS ACCEPTED INPUT ACTION ////
            // Décocher le dernier type laisse les SMS activés : le vendeur choisit ses types ensuite
            // (fiche vendeur ou app mobile), y compris aucun.
            let typesSmsAccepted = $('.types-sms-accepted input');
            typesSmsAccepted.change(function(){
                let enableSmsInput = $('.enable-sms-input');
                if ($(this).is(':checked') && enableSmsInput.is(':checked') === false) {
                    enableSmsInput.prop('checked', true);
                }
            });
        }

        function handleLockData()
        {
            const lockData = $('.lock-data');
            // Handle on page loaded
            lockData.each(function(){
                handleLockDataItem($(this), false)
            });
            // Handle on input click
            lockData.click(function(event){
                event.preventDefault();
                handleLockDataItem($(this), true)
            });

            function handleLockDataItem(element, change) {
                const input = element.next('input[type=hidden]');
                const data = element.attr('data-to-lock');
                if ((change && input.val() === '1') || (!change && input.val() === '0')) {
                    input.val(0);
                    element
                        .removeClass('--red').addClass('--green')
                        .removeClass('scorimmo-icon-Other-Lock').addClass('scorimmo-icon-Other-Unlock')
                        .attr('data-title', translate('app.user.lock_data'));
                    $('[data-lock='+data+']').prop('readonly', false).parents('.switch').removeClass('readonly');
                } else {
                    input.val(1);
                    element
                        .removeClass('--green').addClass('--red')
                        .removeClass('scorimmo-icon-Other-Unlock').addClass('scorimmo-icon-Other-Lock')
                        .attr('data-title', translate('app.user.unlock_data'));
                    $('[data-lock='+data+']').prop('readonly', true).parents('.switch').addClass('readonly');
                }
                // Notifie les sectionHandlers (SMS/Emails) que le verrou a changé
                // pour qu'ils recalculent leur état (disable + uncheck si locked, réactiver
                // les switches si unlocked — sans rejouer les défauts, cf. specs).
                element.trigger('lock-changed', [data, input.val() === '1']);
                launchTooltip();
            }
        }

        function emailSectionHandler() {
            const $emailField = container.find('#seller_email');
            if (!$emailField.length) return;

            const emailsSection = container.find('.form-block.--emails');
            const targetInfo = emailsSection.find('.email-target-info');
            const labels = {
                tooltip: targetInfo.data('no-email-tooltip') || '',
                noEmail: targetInfo.data('no-email') || '',
                locked: targetInfo.data('locked') || '',
            };
            const mailCheckboxes = emailsSection.find('input[type="checkbox"]');
            const mailSwitchContainers = emailsSection.find('.switch-container');
            const mailFields = emailsSection.find('.field.--flex');

            mailFields.each(function () {
                const $f = $(this);
                if ($f.data('original-title') === undefined) {
                    $f.data('original-title', $f.attr('data-title') || '');
                }
            });

            // Snapshot des états DB à l'init pour restauration sur transition invalide → valide.
            const initialMailState = new Map();
            mailCheckboxes.each(function () {
                initialMailState.set(this, this.checked);
            });
            let userTouchedMail = false;
            mailCheckboxes.on('change', function () {
                if (!this.disabled) userTouchedMail = true;
            });
            let wasValid = null;
            let lastValid = false;
            const $lockInput = container.find('#seller_lockMail');
            function isLocked() {
                return $lockInput.val() === '1';
            }

            function applyState(isValid) {
                lastValid = isValid;
                const locked = isLocked();
                const enabled = isValid && !locked;
                // Restauration uniquement sur transition invalide → valide (pas sur déverrouillage) :
                // si l'utilisateur déverrouille, on ne rejoue pas les défauts (cf. specs).
                const becameValid = wasValid === false && enabled;

                mailCheckboxes.prop('disabled', !enabled);
                if (!enabled) {
                    mailCheckboxes.filter(':checked').prop('checked', false).trigger('change');
                } else if (becameValid && !userTouchedMail) {
                    // 1. Restaurer l'état DB initial (utile pour les fiches existantes
                    //    où enableMail=true était en DB avant que notre disable ne l'écrase).
                    mailCheckboxes.each(function () {
                        const initial = initialMailState.get(this);
                        if (this.checked !== initial) {
                            $(this).prop('checked', initial).trigger('change');
                        }
                    });
                    // 2. Fiche vierge (enableMail initialement false) : auto-cocher enableMail
                    //    + cascade des types par défaut (data-default en Twig), équivalent au clic utilisateur.
                    const $enableMail = emailsSection.find('.enable-mail-input');
                    if (!$enableMail.is(':checked')) {
                        $enableMail.prop('checked', true).trigger('change');
                        emailsSection.find('.types-mails-accepted input[data-default]').not(':checked')
                            .prop('checked', true).trigger('change');
                    }
                    userTouchedMail = false;
                }

                mailSwitchContainers.toggleClass('--disabled', !enabled);
                mailFields.each(function () {
                    const $f = $(this);
                    $f.attr('data-title', enabled ? ($f.data('original-title') || '') : labels.tooltip);
                });

                if (locked) {
                    targetInfo.text(labels.locked).addClass('--no-email');
                } else if (isValid) {
                    targetInfo.text($emailField.val()).removeClass('--no-email');
                } else {
                    targetInfo.text(labels.noEmail).addClass('--no-email');
                }

                wasValid = isValid;
                launchTooltip();
            }

            // Recalcule l'état quand le verrou change (déverrouiller = ré-appliquer les défauts si email valide)
            $(document).on('lock-changed', '.lock-data[data-to-lock=mail]', function () {
                applyState(lastValid);
            });

            bindEmailValidation($emailField, {
                baseTitle: translate('app.user.form.title.email'),
                onResult: applyState,
            });
        }


        function formValidation()
        {
            $('.main-content-resp form').submit(function(e){
                const baseForm = $(this);
                if (removedInterests.length === 0) {
                    return true;
                } else {

                    if (!confirmationState) {

                        e.preventDefault();

                        const { userId } = pageConfig();
                        let url = Routing.generate('user_remove_interest', {'user': userId, 'interests': removedInterests});

                        let requestHeaders = new Headers({
                            'X-Requested-With': 'XMLHttpRequest'
                        });
                        let requestInit = { method: 'GET',
                            headers: requestHeaders,
                        };

                        fetch(url, requestInit)
                            .then(response => response.json())
                            .then(data => {
                                if (data.ok) {
                                    // on soumet le formulaire utilisateur
                                    confirmationState = true;
                                    baseForm.submit();
                                    return true;
                                }
                                else if (data.template) {
                                    openConfirmation({'class': '--white --high', 'element': $("#user-archive-form-modal"), 'afterClose': afterClose, 'action': validateFormAction});
                                    $('.user-archive-form-modal-content').html(data.template).removeClass('--hidden');
                                    $('.user-archive-form-modal-loader-wrapper').addClass('--hidden');
                                    let form = $('.reassign-lead-form-wrapper');
                                    form.find('.confirm').on('click', function() {
                                        validateFormAction(baseForm);
                                    })
                                    form.find('.cancel').on('click', function() {
                                        $('body > .pop-overlay').addClass('--hidden');
                                        $('body > .pop-confirmation').addClass('--hidden');
                                        return false;
                                    })

                                    const posSelect = $('.reaffectPosLeadLine-posSelect select');
                                    const sellerSelect = $('.reaffectPosLeadLine-sellerSelect select');

                                    posSelect.select2();
                                    sellerSelect.select2();
                                    updatePosListUser(posSelect);
                                }
                            })
                            .catch(function(error) {
                                reportError('user_remove_interest a échoué', error);
                            });
                    }
                }
                return true;
            });
        }

        function availableForLeadHandlerAction()
        {
            updateAffectationSectionVisibility();

            interestAssignmentSelect.on('change', updateAffectationSectionVisibility);
        }

        function updateAffectationSectionVisibility()
        {
            const hasAssignedInterest = (interestAssignmentSelect.val() || []).length > 0;

            if (hasAssignedInterest) {
                affectationSection.removeClass('--hidden');
            } else {
                affectationSection.addClass('--hidden');
            }
        }

        function smsSectionHandler()
        {
            const smsSection = container.find('.form-block.--sms');
            if (!smsSection.length) return;

            const smsSwitchContainers = smsSection.find('.switch-container');
            const smsCheckboxes = smsSection.find('input[type="checkbox"]');
            const smsFields = smsSection.find('.field.--flex');
            const targetInfo = smsSection.find('.sms-target-info');
            const labels = {
                tooltip: targetInfo.data('no-mobile-tooltip') || '',
                noMobile: targetInfo.data('no-mobile') || '',
                locked: targetInfo.data('locked') || '',
            };

            smsFields.each(function () {
                const $f = $(this);
                if ($f.data('original-title') === undefined) {
                    $f.data('original-title', $f.attr('data-title') || '');
                }
            });

            const mobileState = { principal: null, secondary: null };
            const phoneNode = phoneNumberInput.get(0);
            const mobilePhoneNode = mobilePhoneNumberInput.get(0);

            // Snapshot des états DB à l'init pour restauration sur transition invalide → valide.
            const initialSmsState = new Map();
            smsCheckboxes.each(function () {
                initialSmsState.set(this, this.checked);
            });
            let userTouchedSms = false;
            smsCheckboxes.on('change', function () {
                if (!this.disabled) userTouchedSms = true;
            });
            let wasHasTarget = null;
            const $lockInput = container.find('#seller_lockSms');
            function isLocked() {
                return $lockInput.val() === '1';
            }

            function pickTargetNumber() {
                if (mobileState.principal === true) return (phoneNumberInput.val() || '').trim();
                if (mobileState.secondary === true) return (mobilePhoneNumberInput.val() || '').trim();
                return null;
            }

            function bothEvaluated() {
                const principalDone = mobileState.principal !== null || !(phoneNumberInput.val() || '').trim();
                const secondaryDone = mobileState.secondary !== null || !(mobilePhoneNumberInput.val() || '').trim();
                return principalDone && secondaryDone;
            }

            function applyState() {
                if (!bothEvaluated()) return;

                const target = pickTargetNumber();
                const hasTarget = target !== null;
                const locked = isLocked();
                const enabled = hasTarget && !locked;
                // Restauration uniquement sur transition mobile invalide → valide
                // (pas sur déverrouillage) : si l'utilisateur déverrouille, on ne rejoue pas les défauts.
                const becameValid = wasHasTarget === false && enabled;

                smsCheckboxes.prop('disabled', !enabled);
                if (!enabled) {
                    smsCheckboxes.filter(':checked').prop('checked', false).trigger('change');
                } else if (becameValid && !userTouchedSms) {
                    // 1. Restaurer l'état DB initial (utile pour les fiches existantes
                    //    où enableSms=true était en DB avant que notre disable ne l'écrase).
                    smsCheckboxes.each(function () {
                        const initial = initialSmsState.get(this);
                        if (this.checked !== initial) {
                            $(this).prop('checked', initial).trigger('change');
                        }
                    });
                    // 2. Fiche vierge (enableSms initialement false) : auto-cocher enableSms
                    //    + cascade des types par défaut (data-default en Twig), équivalent au clic utilisateur.
                    const $enableSms = smsSection.find('.enable-sms-input');
                    if (!$enableSms.is(':checked')) {
                        $enableSms.prop('checked', true).trigger('change');
                        smsSection.find('.types-sms-accepted input[data-default]').not(':checked')
                            .prop('checked', true).trigger('change');
                    }
                    userTouchedSms = false;
                }

                smsSwitchContainers.toggleClass('--disabled', !enabled);
                smsFields.each(function () {
                    const $f = $(this);
                    $f.attr('data-title', enabled ? ($f.data('original-title') || '') : labels.tooltip);
                });

                if (locked) {
                    targetInfo.text(labels.locked).addClass('--no-mobile');
                } else if (hasTarget) {
                    targetInfo.text(target).removeClass('--no-mobile');
                } else {
                    targetInfo.text(labels.noMobile).addClass('--no-mobile');
                }

                wasHasTarget = hasTarget;

                launchTooltip();
            }

            // Recalcule l'état quand le verrou change (déverrouiller = ré-appliquer les défauts si mobile valide)
            $(document).on('lock-changed', '.lock-data[data-to-lock=sms]', function () {
                applyState();
            });

            function bind(node, key) {
                if (!node) return;
                node.addEventListener('phone-validated', function (e) {
                    const detail = e.detail || {};
                    mobileState[key] = !!(detail.isValid && detail.isMobile);
                    applyState();
                });
                node.addEventListener('input', function () {
                    if (!node.value.trim()) {
                        mobileState[key] = null;
                        applyState();
                    }
                });
            }

            bind(phoneNode, 'principal');
            bind(mobilePhoneNode, 'secondary');

            applyState();
        }

        function titleAutoResolveHandler()
        {
            const firstNameInput = container.find('#seller_firstName');
            const titleInput = container.find('#seller_title');
            if (!firstNameInput.length || !titleInput.length) return;

            let lastResolved = null;

            function resolve() {
                const firstName = (firstNameInput.val() || '').trim();
                if (firstName === '' || firstName === lastResolved) return;
                lastResolved = firstName;

                fetch(Routing.generate('resolve_title'), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: `first_name=${encodeURIComponent(firstName)}`,
                })
                    .then(res => res.ok ? res.json() : null)
                    .then(data => {
                        if (!data) return;
                        if (data.title === 'Mme' && !titleInput.is(':checked')) {
                            titleInput.prop('checked', true).trigger('change');
                        } else if (data.title === 'M.' && titleInput.is(':checked')) {
                            titleInput.prop('checked', false).trigger('change');
                        }
                    })
                    .catch(() => {
                        // Détection du genre best-effort : un échec ne doit pas
                        // interrompre la saisie du formulaire.
                    });
            }

            firstNameInput.on('blur', resolve);
        }

        function transferVisibilityHandler()
        {
            const transferInitiallyChecked = rightInputs.rightTransfer.is(':checked');
            let userTouchedTransfer = false;
            let wasValid = null;

            rightInputs.rightTransfer.on('change', function () {
                if (!rightInputs.rightTransfer.prop('disabled')) {
                    userTouchedTransfer = true;
                }
            });

            function getFavoritePhoneInput() {
                return favoritePhoneNumberInput.is(':checked') ? mobilePhoneNumberInput : phoneNumberInput;
            }

            function isFavoritePhoneValid() {
                const $input = getFavoritePhoneInput();
                if (!$input.length) return false;
                const value = ($input.val() || '').trim();
                if (!value) return false;
                return !$input.hasClass('--error');
            }

            function updateTransferAvailability() {
                const activeTitle = transferField.data('title-active') || transferField.attr('data-title');
                const lockedTitle = transferField.data('title-locked') || activeTitle;
                const transferTarget = transferField.find('.transfer-target');
                const isValid = isFavoritePhoneValid();
                const becameValid = wasValid === false && isValid;

                if (isValid) {
                    rightInputs.rightTransfer.prop('disabled', false);
                    transferField.find('.switch').removeClass('readonly');
                    transferField.attr('data-title', activeTitle);
                    transferTarget.text((getFavoritePhoneInput().val() || '').trim());
                    // Auto-check si :
                    //  - fiche initialement checked et jamais touchée par user, OU
                    //  - transition invalide → valide (nouveau numéro ajouté)
                    // et pas déjà coché, et non touché manuellement par user.
                    if (!userTouchedTransfer && !rightInputs.rightTransfer.is(':checked')
                        && (transferInitiallyChecked || becameValid)) {
                        rightInputs.rightTransfer.prop('checked', true).trigger('change');
                        userTouchedTransfer = false;
                    }
                } else {
                    // Ordre important : poser disabled AVANT le uncheck programmatique
                    // pour que le handler `change` filtre correctement (!this.disabled)
                    // et ne marque pas userTouchedTransfer=true sur notre propre reset.
                    rightInputs.rightTransfer.prop('disabled', true);
                    transferField.find('.switch').addClass('readonly');
                    if (rightInputs.rightTransfer.is(':checked')) {
                        rightInputs.rightTransfer.prop('checked', false).trigger('change');
                    }
                    transferField.attr('data-title', lockedTitle);
                    transferTarget.text('');
                }

                wasValid = isValid;

                const fieldEl = transferField.get(0);
                if (fieldEl && fieldEl._tippy) {
                    fieldEl._tippy.setContent(transferField.attr('data-title'));
                }
            }

            phoneNumberInput.on('phone-validated input', updateTransferAvailability);
            mobilePhoneNumberInput.on('phone-validated input', updateTransferAvailability);
            favoritePhoneNumberInput.on('change', updateTransferAvailability);
            selectRoles.on('change', updateTransferAvailability);

            updateTransferAvailability();
        }

        function monthlyStatRoleHandlerAction()
        {
            const initiallyChecked = monthlyReportEmailCheckbox.is(':checked');
            let userTouched = false;
            monthlyReportEmailCheckbox.on('change', function () {
                if (!this.disabled) userTouched = true;
            });
            let wasVisible = null;

            function refresh() {
                const isVisible = rightInputs.rightMonthlyStats.is(':checked');
                const becameVisible = wasVisible === false && isVisible;

                if (isVisible) {
                    monthlyReportEmailCheckbox.prop('disabled', false);
                    monthlyReportEmailCheckbox.parents('.field').removeClass('--hidden');
                    if (becameVisible && !userTouched && initiallyChecked && !monthlyReportEmailCheckbox.is(':checked')) {
                        monthlyReportEmailCheckbox.prop('checked', true).trigger('change');
                        userTouched = false;
                    }
                } else {
                    // disabled=true AVANT le uncheck : le handler `change` filtre `!this.disabled`
                    // et ne marque pas userTouched=true sur notre propre reset programmatique.
                    monthlyReportEmailCheckbox.prop('disabled', true);
                    if (monthlyReportEmailCheckbox.is(':checked')) {
                        monthlyReportEmailCheckbox.prop('checked', false).trigger('change');
                    }
                    monthlyReportEmailCheckbox.parents('.field').addClass('--hidden');
                }
                wasVisible = isVisible;
            }

            refresh();
            rightInputs.rightMonthlyStats.change(refresh);
        }

        function internalStatRoleHandlerAction()
        {
            const initiallyChecked = internalStatsCheckbox.is(':checked');
            let userTouched = false;
            internalStatsCheckbox.on('change', function () {
                if (!this.disabled) userTouched = true;
            });
            let wasVisible = null;

            function refresh() {
                const isVisible = rightInputs.rightInternalStats.is(':checked');
                const becameVisible = wasVisible === false && isVisible;

                if (isVisible) {
                    internalStatsCheckbox.prop('disabled', false);
                    internalStatsCheckbox.parents('.field').removeClass('--hidden');
                    if (becameVisible && !userTouched && initiallyChecked && !internalStatsCheckbox.is(':checked')) {
                        internalStatsCheckbox.prop('checked', true).trigger('change');
                        userTouched = false;
                    }
                } else {
                    internalStatsCheckbox.prop('disabled', true);
                    if (internalStatsCheckbox.is(':checked')) {
                        internalStatsCheckbox.prop('checked', false).trigger('change');
                    }
                    internalStatsCheckbox.parents('.field').addClass('--hidden');
                }
                wasVisible = isVisible;
            }

            refresh();
            rightInputs.rightInternalStats.change(refresh);
        }

        function initInterestSelects()
        {
            $.each(interestSelects, function(){

                const $select = $(this);

                $select.select2({
                    placeholder: $select.data('placeholder'),
                    templateResult: data => formatInterestOption(data, $(data.element).data('id') || ''),
                    templateSelection: function(data) {
                        return formatInterestSelection(data, $(data.element).data('id') || '');
                    },
                });

            });

            updateAssignedInterestsSelectList(true);
        }

        function handleSelectOrganization()
        {
            $(document).on('select2:select', '.main-content-resp.--seller .select-organizations', function(e) {
                let selectedOrganizationId = e.params.data.id;
                const { userId, addOrganizationPath } = pageConfig();
                if (userId !== undefined && addOrganizationPath !== undefined) {
                    ajaxRequestOrganisation(addOrganizationPath, selectedOrganizationId, function() {
                        unselectSelect2Option(selectOrganizations, selectedOrganizationId);
                    });
                } else {
                    updateBilledPosSelect(selectedOrganizationId);
                }
            })
            selectOrganizations.on('change', function(){
                const { userId, addOrganizationPath } = pageConfig();
                if (userId === undefined || addOrganizationPath === undefined) {
                    updateAssignedInterestsSelectList();
                }
            })
        }

        function handleRemoveOrganization() {
            $(document).on('select2:unselecting', '.main-content-resp.--seller .select-organizations', async function(e) {
                e.preventDefault(); // empêche la suppression par défaut pour pouvoir contrôler

                const select = $(this);
                const removedOrganizationId = e.params.args.data.id; // note : en unselecting, c'est params.args.data

                // vérifie qu'il reste au moins 1 option
                if ((select.val() || []).length === 1) {
                    $('.organisation-error-min')
                        .removeClass('--hidden')
                        .delay(2000)
                        .addClass('--hidden');
                    return false; // annule la suppression
                }

                selectOrganizationsLoading();

                const { userId, removeOrganizationPath } = pageConfig();
                if (userId !== undefined && removeOrganizationPath !== undefined) {
                    const canRemove = await ajaxCheckIfOrganizationCanBeRemoved(removedOrganizationId);
                    if (!canRemove) {
                        selectOrganizationsLoaded();
                        return false; // annule la suppression
                    }
                    ajaxRequestOrganisation(removeOrganizationPath, removedOrganizationId, function() {
                        select.find('option[value="' + removedOrganizationId + '"]').prop('selected', true);
                        select.trigger('change');
                    });
                } else {
                    updateAssignedInterestsSelectList();
                    updateBilledPosSelect(removedOrganizationId, 'forceRemove');
                }

                selectOrganizationsLoaded();
                unselectSelect2Option(select, removedOrganizationId); // suppression forcée si tout ok
            });
        }

        function unselectSelect2Option(select2Element, optionValue)
        {
            let select2OptionToDelete = select2Element.find('option[value="'+ optionValue +'"]');
            select2OptionToDelete.prop('selected', false);
            select2Element.trigger('change');
        }

        async function ajaxCheckIfOrganizationCanBeRemoved(posToRemoveId)
        {
            let canBeRemoved = false

            const { userId, posCanBeDeletedPath } = pageConfig();
            if (posCanBeDeletedPath !== undefined && userId !== undefined) {
                await $.post(posCanBeDeletedPath, { posToRemoveId: posToRemoveId, userId: userId })
                    .done(function(data) {
                        if (data.error) {
                            canBeRemoved = false;
                        }
                        if (data.template) {
                            formClosePosModalLoader.addClass('--hidden');
                            formClosePosModalContent.html(data.template);
                            formClosePosModalLink.click();
                            fillFormModalBillingInput(posToRemoveId);
                            canBeRemoved = false;
                            const posSelect = $('.reaffectPosLeadLine-posSelect select');
                            const sellerSelect = $('.reaffectPosLeadLine-sellerSelect select');

                            posSelect.select2();
                            sellerSelect.select2();
                            updatePosListUser(posSelect);
                        }
                        if (data.canBeRemoved) {
                            canBeRemoved = true;
                        }
                    })
                    .fail(function() {
                        canBeRemoved = false;
                    })
                ;
            }

            return canBeRemoved;
        }

        function fillFormModalBillingInput(posIdToNotInclude)
        {
            let selectedOrganizations = selectOrganizations.val();
            let reassignPosBillingSelect = $('.reassignPosBilling');

            selectedOrganizations.forEach(function(val){
                if (val !== posIdToNotInclude) {
                    reassignPosBillingSelect.append($('<option>', {
                        value: val,
                        text: selectOrganizations.find('option[value="' + val + '"]').text()
                    }));
                }
            });

            reassignPosBillingSelect.select2();
        }

        /**
         * @param {string} url
         * @param {string|number} organizationId
         * @param {function} revertSelection remet le select dans l'état du serveur si la requête est refusée
         */
        function ajaxRequestOrganisation(url, organizationId, revertSelection)
        {
            const { userId } = pageConfig();
            if (userId !== undefined) {
                selectOrganizationsWrapper.addClass('--hidden');
                selectOrganizationsLoader.removeClass('--hidden').find('.common-loader').removeClass('--hidden');
                $.post(url, { userId: userId, organizationId: organizationId })
                    .done(function(response) {
                        if (response['status-code'] === 200) {
                            selectOrganizationsWrapper.removeClass('--hidden');
                            selectOrganizationsLoader.addClass('--hidden');
                            updateAssignedInterestsSelectList();
                            updateBilledPosSelect();
                        }
                    })
                    .fail(function(xhr) {
                        // PDV ou utilisateur hors périmètre (403/404), dernier PDV retiré (400).
                        console.error('Organisation de l\'utilisateur non modifiée : HTTP ' + xhr.status);
                        selectOrganizationsWrapper.removeClass('--hidden');
                        selectOrganizationsLoader.addClass('--hidden');
                        revertSelection();
                        openConfirmation({'text': translate('app.error.generic'), 'confirmText': translate('app.common.close'), 'alert': true});
                    });
            }
        }

        function updateAssignedInterestsSelectList(isInitial = false)
        {
            let posIds = selectOrganizations.val() || [];

            const { posInterestIdsPath } = pageConfig();
            if (posIds.length !== 0 && posInterestIdsPath !== undefined) {

                interestLoader.removeClass('--hidden');
                interestSelectWrapper.addClass('--hidden');

                $.post(posInterestIdsPath, { posIds: posIds })
                    .done(function(response) {

                        let availableInterestIds = typeof response['available_interest_ids'] === 'object'
                            ? Object.values(response['available_interest_ids'])
                            : response['available_interest_ids'];

                        manageInterestsDisplay(availableInterestIds, isInitial);
                    });
            } else {
                interestLoader.addClass('--hidden');
                interestSelectWrapper.removeClass('--hidden');
            }

            // stocker les intérêts initiaux
            const $select = interestAssignmentSelect;

            let initialValues = $select.val() || [];

            initialValues.forEach(v => {
                if (!originalInterests.includes(v)) {
                    originalInterests.push(v);
                }
            });

            $select.off('change.interests').on('change.interests', function () {

                const values = $(this).val() || [];

                // vérifier les intérêts retirés
                originalInterests.forEach(v => {

                    if (!values.includes(v) && !removedInterests.includes(v)) {
                        removedInterests.push(v);
                    }

                    if (values.includes(v)) {
                        const index = removedInterests.indexOf(v);
                        if (index !== -1) {
                            removedInterests.splice(index, 1);
                        }
                    }

                });

            });
        }

        function manageInterestsDisplay(availableInterestIds, isInitial = false)
        {
            interestSelects.each(function() {

                const $select = $(this);

                $select.find('option').each(function(){

                    const value = parseInt($(this).val());

                    if (availableInterestIds.includes(value)) {

                        $(this).prop('disabled', false);

                    } else {

                        $(this).prop('disabled', true);

                        if (!isInitial) {
                            const currentValues = $select.val() || [];

                            if (currentValues.includes($(this).val())) {

                                const newValues = currentValues.filter(v => v !== $(this).val());

                                $select.val(newValues).trigger('change.select2');

                            }
                        }

                    }

                });

                // refresh select2
                $select.trigger('change.select2');

            });

            interestLoader.addClass('--hidden');
            interestSelectWrapper.removeClass('--hidden');
        }

        function initializeBilledPosField()
        {
            let selectedOrganizations = [];
            if (selectOrganizations.val() != null) {
                selectedOrganizations = selectOrganizations.val();
            }

            let selectBilledPosOption = selectBilledPos.find('option');

            selectBilledPosOption.each(function(){
                let optionVal = $(this).val();
                if (!selectedOrganizations.includes(optionVal)) {
                    $(this).remove();
                }
            })

            selectBilledPos.select2();
        }

        function updateBilledPosSelect(selectedOrganizationId = null, action = null)
        {
            selectBilledPosLoader.removeClass('--hidden');
            selectBilledPosWrapper.addClass('--hidden');
            let selectedOrganizations = [];

            if (selectOrganizations.val()) {
                selectedOrganizations = selectOrganizations.val();
            }

            let lastBilledPosSelectedId = null;
            if (selectBilledPos.val()) {
                lastBilledPosSelectedId = selectBilledPos.val().toString();
            }

            if (selectedOrganizationId && action !== 'forceRemove') {
                selectedOrganizations.push(selectedOrganizationId)
            }

            selectBilledPos.find('option').remove();

            selectedOrganizations.forEach(function(val){
                if (action !== 'forceRemove' || selectedOrganizationId !== val) {
                    selectBilledPos.append($('<option>', {
                        value: val,
                        text: selectOrganizations.find('option[value="' + val + '"]').text()
                    }));
                }
            });

            // pre-select last selection
            if (lastBilledPosSelectedId && selectedOrganizations.includes(lastBilledPosSelectedId)) {
                selectBilledPos.val(lastBilledPosSelectedId);
            }

            selectBilledPos.select2();

            // simulate 3 seconds loading, treatment is too fast
            setTimeout(function () {
                selectBilledPosLoader.addClass('--hidden');
                selectBilledPosWrapper.removeClass('--hidden');
            }, 3000);
        }

        function handleArchiveUserAction()
        {
            archiveUserLink.click(function(e){
                e.preventDefault();
                let url = $(this).data('href');

                let requestHeaders = new Headers({
                    'X-Requested-With': 'XMLHttpRequest',
                    ...csrfHeaders(),
                });
                let requestInit = { method: 'POST',
                    headers: requestHeaders,
                };

                fetch(url, requestInit)
                    .then(response => {
                        if (!response.ok) throw new Error(`archive-user HTTP ${response.status}`);
                        return response.json();
                    })
                    .then(data => {
                        if (data.redirectUrl) {
                            location.href = data.redirectUrl;
                        }
                        if (data.template) {
                            $('.user-archive-form-modal-content').html(data.template).removeClass('--hidden');
                            $('.user-archive-form-modal-loader-wrapper').addClass('--hidden');
                            let form = $('.reassign-lead-form-wrapper');
                            form.find('.confirm').on('click', function() {
                                validateFormAction();
                            })
                            form.find('.cancel').on('click', function() {
                                $('body > .pop-overlay').addClass('--hidden');
                                $('body > .pop-confirmation').addClass('--hidden');
                            })

                            const posSelect = $('.reaffectPosLeadLine-posSelect select');
                            const sellerSelect = $('.reaffectPosLeadLine-sellerSelect select');

                            posSelect.select2();
                            sellerSelect.select2();
                            updatePosListUser(posSelect);
                        }
                    })
                    .catch(function(error) {
                        reportError("Archivage de l'utilisateur impossible", error);
                        showFlash($('.js-flash-message-error'), translate('app.error.generic'), true);
                    });
            })
        }

        function selectOrganizationsLoading()
        {
            selectOrganizationsWrapper.addClass('--hidden');
            selectOrganizationsLoader.removeClass('--hidden');
        }

        function selectOrganizationsLoaded()
        {
            selectOrganizationsWrapper.removeClass('--hidden');
            selectOrganizationsLoader.addClass('--hidden');
        }

        function handleUnarchiveUserAction()
        {
            unarchiveUserLink.click(function(e){
                e.preventDefault();
                $(this).addClass('--hidden');
                unarchiveUserLoader.removeClass('--hidden');

                let url = $(this).data('href');
                let requestHeaders = new Headers({
                    'X-Requested-With': 'XMLHttpRequest',
                    ...csrfHeaders(),
                });
                let requestInit = { method: 'POST',
                    headers: requestHeaders,
                };
                const unarchiveLink = $(this);
                fetch(url, requestInit)
                    .then(response => {
                        if (!response.ok) throw new Error(`unarchive-user HTTP ${response.status}`);
                        return response.json();
                    })
                    .then(data => {
                        if (data.status !== 200) throw new Error(`unarchive-user status ${data.status}`);
                        location.reload();
                    })
                    .catch(function(error) {
                        reportError("Désarchivage de l'utilisateur impossible", error);
                        unarchiveUserLoader.addClass('--hidden');
                        unarchiveLink.removeClass('--hidden');
                        showFlash($('.js-flash-message-error'), translate('app.error.generic'), true);
                    });
            })
        }

        // Snapshot des états initiaux + flags user-touched pour les checkboxes contrôlées par updateRoleDisplay :
        // sur transition role restrictif → permissif, restaurer l'état DB si non modifié manuellement.
        const roleRestorableInputs = [
            rightInputs.rightMonthlyStats,
            rightInputs.rightExternalBilling,
            rightInputs.canManageAc3Connection,
            weeklyReportRoleInput,
            rightInputs.rightInternalStats,
        ];
        // Inputs affectés par le passage en/hors Technique (auto-uncheck MCP + auto-check Doc à l'entrée) :
        // on garde une trace pour restaurer l'état DB initial à la sortie de Technique.
        const technicalTransitionInputs = [
            rightInputs.rightMcp,
            rightInputs.rightMcpFormWrite,
            rightInputs.anonymizedMcp,
            rightInputs.rightDocumentation,
        ];
        const roleInitialState = new Map();
        const roleUserTouched = new Map();
        [...roleRestorableInputs, ...technicalTransitionInputs].forEach($input => {
            const el = $input.get(0);
            if (!el) return;
            roleInitialState.set(el, el.checked);
            roleUserTouched.set(el, false);
            $input.on('change', function () {
                if (!this.disabled) roleUserTouched.set(this, true);
            });
        });
        const ROLE_FIELDS = {
            monthlyStat:        () => rightInputs.rightMonthlyStats,
            smsCampaign:        () => rightInputs.rightSmsCampaign,
            externalBilling:    () => rightInputs.rightExternalBilling,
            ac3Connection:      () => rightInputs.canManageAc3Connection,
            weeklyReport:       () => weeklyReportRoleInput,
            internalStats:      () => rightInputs.rightInternalStats,
            interestAssignment: () => interestAssignmentSelect,
            interestVisible:    () => interestVisibleSelect,
        };

        const CHECKBOX_FIELDS = new Set(['monthlyStat', 'externalBilling', 'ac3Connection', 'weeklyReport', 'internalStats', 'smsCampaign']);

        const ROLE_CONFIG = {
            ROLE_SELLER: {
                show:      ['interestAssignment'],
                hide:      ['monthlyStat', 'externalBilling', 'ac3Connection', 'weeklyReport', 'internalStats', 'smsCampaign'],
                clear:     ['interestVisible'],
                mandatory: { interestAssignment: true,  interestVisible: false },
                bulk:      { isTechnical: false, virtual: false },
            },
            ROLE_SALES_MANAGER: {
                show:      ['monthlyStat', 'externalBilling', 'ac3Connection', 'weeklyReport', 'interestAssignment', 'interestVisible', 'smsCampaign'],
                hide:      ['internalStats'],
                clear:     [],
                mandatory: { interestAssignment: false, interestVisible: false },
                bulk:      { isTechnical: false, virtual: false },
            },
            ROLE_GROUP_DIRECTOR: {
                show:      ['monthlyStat', 'externalBilling', 'ac3Connection', 'weeklyReport', 'internalStats', 'interestAssignment', 'interestVisible', 'smsCampaign'],
                hide:      [],
                clear:     [],
                mandatory: { interestAssignment: false, interestVisible: false },
                bulk:      { isTechnical: false, virtual: false },
            },
            ROLE_TECHNICAL: {
                show:      ['interestVisible'],
                hide:      ['monthlyStat', 'externalBilling', 'ac3Connection', 'weeklyReport', 'internalStats', 'smsCampaign'],
                clear:     ['interestAssignment'],
                mandatory: { interestAssignment: false, interestVisible: true },
                bulk:      { isTechnical: true,  virtual: false },
            },
            ROLE_VIRTUAL: {
                show:      ['interestAssignment'],
                hide:      ['monthlyStat', 'externalBilling', 'ac3Connection', 'weeklyReport', 'internalStats', 'smsCampaign'],
                clear:     ['interestVisible'],
                mandatory: { interestAssignment: false, interestVisible: false },
                bulk:      { isTechnical: false, virtual: true },
            },
        };

        const ROLE_TRANSITIONS = {
            ROLE_TECHNICAL: {
                onEnter: () => [
                    { input: rightInputs.rightMcp, value: false },
                    { input: rightInputs.rightDocumentation, value: true },
                ],
                onExitRestore: () => technicalTransitionInputs,
            },
        };

        let previousRole = null;

        // disable + uncheck AVANT masquage — le handler `change` sur roleUserTouched
        // filtre `!this.disabled` et ignore notre propre reset. `disabled` doit être posé
        // même au chargement initial (isInitial) pour que le champ apparaisse grisé dès le
        // départ ; seul le reset du `checked` (qui déclenche un `change`) reste protégé.
        const hideField = ($input, isInitial) => {
            $input.prop('disabled', true);
            if (!isInitial && $input.is(':checked')) {
                $input.prop('checked', false).trigger('change');
            }
            $input.parents('.field').addClass('--hidden');
        };
        const clearSelect = ($select, isInitial) => {
            if (!isInitial) $select.val('').trigger('change');
            $select.parents('.field').addClass('--hidden');
        };
        const showAndRestore = ($input, isInitial) => {
            $input.prop('disabled', false);
            $input.parents('.field').removeClass('--hidden');
            if (isInitial) return;
            const el = $input.get(0);
            if (!el || !roleInitialState.has(el)) return;
            if (!roleUserTouched.get(el) && roleInitialState.get(el) && !el.checked) {
                $input.prop('checked', true).trigger('change');
                roleUserTouched.set(el, false);
            }
        };
        const showSelect = ($select) => {
            $select.parents('.field').removeClass('--hidden');
        };

        function updateRoleDisplay(role, isInitial = false) {
            const config = ROLE_CONFIG[role] || ROLE_CONFIG.ROLE_SELLER;

            config.hide.forEach(name => hideField(ROLE_FIELDS[name](), isInitial));
            config.clear.forEach(name => clearSelect(ROLE_FIELDS[name](), isInitial));
            config.show.forEach(name => {
                const $el = ROLE_FIELDS[name]();
                if (CHECKBOX_FIELDS.has(name)) showAndRestore($el, isInitial);
                else showSelect($el);
            });

            Object.entries(config.mandatory).forEach(([name, val]) => {
                ROLE_FIELDS[name]().toggleClass('--mandatory', val);
            });

            noTechnicalElement.toggleClass('--hidden', config.bulk.isTechnical);
            // Synchro classe conteneur `--role-technical` : pilote la règle CSS server-side
            // qui masque `.--no-technical` (cf. user-form.scss) — indispensable pour que
            // le changement de rôle dans le select ré-affiche/masque correctement les sections.
            container.toggleClass('--role-technical', config.bulk.isTechnical);
            virtualHiddenElements.toggleClass('--hidden', config.bulk.virtual);
            // required HTML5 sur un input hidden fait échouer le submit navigateur
            // ("not focusable") → toggle dynamique via dataset.wasRequired.
            if (config.bulk.virtual) {
                virtualHiddenElements.find('input[required], select[required], textarea[required]').each(function () {
                    this.dataset.wasRequired = '1';
                    this.removeAttribute('required');
                });
            } else {
                virtualHiddenElements.find('input, select, textarea').each(function () {
                    if (this.dataset.wasRequired === '1') {
                        this.setAttribute('required', 'required');
                        delete this.dataset.wasRequired;
                    }
                });
            }

            if (!isInitial) {
                const prevTransitions = ROLE_TRANSITIONS[previousRole];
                if (prevTransitions?.onExitRestore) {
                    prevTransitions.onExitRestore().forEach($input => {
                        const el = $input.get(0);
                        if (!el || !roleInitialState.has(el) || roleUserTouched.get(el)) return;
                        const initial = roleInitialState.get(el);
                        if (el.checked !== initial) {
                            $input.prop('checked', initial).trigger('change');
                            roleUserTouched.set(el, false);
                        }
                    });
                }
                const nextTransitions = ROLE_TRANSITIONS[role];
                if (nextTransitions?.onEnter) {
                    nextTransitions.onEnter().forEach(({ input, value }) => {
                        if (input.is(':checked') !== value) {
                            input.prop('checked', value).trigger('change');
                        }
                    });
                }
            }

            previousRole = role;
            updateAffectationSectionVisibility();
            refreshSmsCampaignWarning?.();
        }

        updateRoleDisplay(selectRoles.val(), true);
        selectRoles.on('change', function () {
            updateRoleDisplay($(this).val(), false);
        });

        function statUserToggle()
        {
            if ( rightInputs.rightInternalStats.is(':checked') === false ) {
                blockLibelles.addClass('--hidden');
            }

            rightInputs.rightInternalStats.change(function(){
                if ($(this).is(':checked') === false) {
                    blockLibelles.addClass('--hidden');
                } else {
                    blockLibelles.removeClass('--hidden');
                }
            })
        }

        function validateFormAction(baseForm)
        {
            let form = $('.pop-confirmation .reassign-lead-form');
            let url = form.attr('action');

            let formSerialize = form.serialize();

            $('.user-archive-form-modal-content').addClass('--hidden');
            $('.user-archive-form-modal-loader-wrapper').removeClass('--hidden');
            $('.user-close-pos-form-modal-loader-wrapper').removeClass('--hidden');

            $.post(url, formSerialize, function(response) {
                if (response.interests) {
                    // on soumet le formulaire utilisateur
                    confirmationState = true;
                    baseForm.submit();
                } else if(response.status === 200) {
                    location.reload();
                }
            }).fail(function(error) {
                $('.user-archive-form-modal-loader-wrapper').addClass('--hidden');
                $('.user-archive-form-modal-content').html(error.statusText).removeClass('--hidden');
                toggleSectionContentVisibility();
                reportError("Validation du formulaire d'archivage impossible", error, { status: error.status });
            });
        }

    }

});
